import * as React from 'react'
import { ReactElement, useContext } from 'react'
import { Button, DrawerBody, DrawerHeader, DrawerHeaderTitle, mergeClasses, OverlayDrawer } from '@fluentui/react-components'
import { isOfficeInitialized } from '../helpers/outlookHelper'
import { useTranslation } from 'react-i18next'
import useUser from '../hooks/useUser'
import AuthorizationContext from '../context/AuthorizationContext'
import { useApplicationStyles } from '../pages/App'

type Props = {
    isOpen: boolean
    setIsOpen: (isOpen: boolean) => void
}

export default function MainOverlayDrawer(props: Props): ReactElement {
    const appStyles = useApplicationStyles()
    const { t: translate } = useTranslation()
    const { currentUser } = useUser()
    const { setHost, hosts, reset } = useContext(AuthorizationContext)

    return (
        <OverlayDrawer as={'aside'} position={'end'} open={props.isOpen} onOpenChange={(_, { open }) => props.setIsOpen(open)}>
            <DrawerHeader>
                <DrawerHeaderTitle>{currentUser?.fullName}</DrawerHeaderTitle>
            </DrawerHeader>
            <DrawerBody className={mergeClasses(appStyles.flexColumn, appStyles.gapS)}>
                {(!isOfficeInitialized() || hosts.length > 1) && (
                    <Button
                        appearance={'primary'}
                        // iconProps={{ iconName: 'Leave' }}
                        onClick={() => {
                            if (isOfficeInitialized()) {
                                setHost(undefined)
                            } else {
                                reset()
                            }
                        }}
                    >
                        {translate('menu.logout')}
                    </Button>
                )}
            </DrawerBody>
        </OverlayDrawer>
    )
}
